"use client";
import { cn } from "@/lib/utils";
import React, { ReactNode } from "react";

interface AuroraBackgroundProps extends React.HTMLProps<HTMLDivElement> {
  children: ReactNode;
  showRadialGradient?: boolean;
}

export const AuroraBackground = ({
  className,
  children,
  showRadialGradient = true,
  ...props
}: AuroraBackgroundProps) => {
  return (
    <div className="fixed inset-0 w-screen h-screen overflow-auto bg-white">
      {/* Subtle gradient background */}
      <div className="fixed inset-0 w-screen h-screen bg-gradient-to-b from-white via-pink-50 to-orange-50" />
      
      {/* Very subtle grid texture */}
      <div className="fixed inset-0 w-screen h-screen bg-[linear-gradient(to_right,#00000005_1px,transparent_1px),linear-gradient(to_bottom,#00000005_1px,transparent_1px)] bg-[size:14px_24px]" />
      
      <div className={cn("relative w-full min-h-screen", className)} {...props}>
        {/* Subtle glow effects */}
        <div className="fixed inset-0 w-screen h-screen pointer-events-none">
          <div className="absolute -top-40 -right-40 w-80 h-80 bg-pink-100 rounded-full mix-blend-multiply filter blur-[100px] opacity-20" />
          <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-orange-100 rounded-full mix-blend-multiply filter blur-[100px] opacity-20" />
        </div>
        
        {/* Content */}
        <div className="relative z-10 w-full">
          {children}
        </div>
      </div>
    </div>
  );
};